import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";

function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: 3,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontWeight: "bold",
          fontSize: { xs: "80px", md: "120px" },
          mb: 1,
        }}
      >
        404
      </Typography>

      <Typography variant="h4" sx={{ mb: 2 }}>
        Page Not Found
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 3 }}
      >
        The page you're looking for doesn't exist.
      </Typography>

      <Button
        variant="contained"
        onClick={() => navigate("/Dashboard")}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
}

export default NotFound;